import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { SlPaypal } from "react-icons/sl";
import { LiaDiscord } from "react-icons/lia";
import { discordUrl } from "../../utils/constants";

const HomeSupport = ({ layout = "vertical" }) => {
  const isHorizontal = layout === "horizontal";

  return (
    <Wrapper $horizontal={isHorizontal} className="v-anim-fade-up v-delay-3">
      <Card className="v-card-accent gold">
        <IconWrap><SlPaypal /></IconWrap>
        <CardTitle>AYÚDANOS</CardTitle>
        <CardDesc>
          Tanto para la web como para los premios, necesitamos tu apoyo.
        </CardDesc>
        <Link to="/donations">
          <button className="v-btn-slate" style={{ background: "rgba(0,0,0,0.15)", color: "#fff" }}>
            <SlPaypal /> DONAR
          </button>
        </Link>
      </Card>
      <Card className="v-card-accent uv">
        <IconWrap><LiaDiscord /></IconWrap>
        <CardTitle>COMUNIDAD</CardTitle>
        <CardDesc>
          Únete a nuestro servidor de discord para estar al tanto de todas
          las novedades y torneos.
        </CardDesc>
        <button
          className="v-btn-slate"
          style={{ background: "rgba(255,255,255,0.12)", color: "#fff" }}
          onClick={() => window.open(discordUrl, "_blank")}
        >
          <LiaDiscord /> DISCORD
        </button>
      </Card>
    </Wrapper>
  );
};

const Wrapper = styled.aside`
  display: flex;
  flex-direction: ${({ $horizontal }) => ($horizontal ? "row" : "column")};
  gap: 0.75rem;
  opacity: 0;

  @media (max-width: 700px) {
    flex-direction: column;
  }
`;

const Card = styled.div`
  border-radius: 20px;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  flex: 1;
`;

const IconWrap = styled.div`
  font-size: 1.5rem;
  opacity: 0.7;
`;

const CardTitle = styled.h4`
  font-family: var(--v-font-mono);
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1.8px;
  margin: 0;
`;

const CardDesc = styled.p`
  font-family: var(--v-font-body);
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  margin: 0;
  opacity: 0.85;
`;

export default HomeSupport;
